import TriviaCard from "./TriviaCard";
export default TriviaCard;
